import * as yup from 'yup';

const validateOpeningHoursFormat = (value?: string) => {
  const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9](am|pm)?$/;

  if (!value || !regex.test(value)) {
    throw new yup.ValidationError('Opening hours must be in the format "Day HH:MM AM/PM". Example: "Monday 09:00 AM"', value, 'format');
  }

  return true;
};

export const avaStoreSchema = yup.object().shape({
  _id: yup.string().required(),
  name: yup.string().required(),
  store_code: yup.string().required(),
  is_trading: yup.boolean().required(),
  store_type: yup.string().required(),
  address: yup
    .object()
    .shape({
      address_line_1: yup.string().required(),
      suburb: yup.string().required(),
      postcode: yup.number().required(),
      state: yup.string().required(),
      geo: yup
        .object()
        .shape({
          lat: yup.number().required(),
          lng: yup.number().required(),
        })
        .required(),
    })
    .required(),
  skus: yup.array().of(yup.mixed()).required(),
  opening_hours: yup
    .array()
    .of(
      yup.object().shape({
        day: yup.string().required(),
        open: yup.string().test('opening-hours-format', 'Invalid opening hours format', validateOpeningHoursFormat).required(),
        closed: yup.string().test('opening-hours-format', 'Invalid opening hours format', validateOpeningHoursFormat).required(),
      }),
    )
    .required(),
});
